import moment from 'moment'
import { easternToday, getAggregation } from 'shared/lib/helpers'
import {
  DASHBOARD_FAILURE,
  DASHBOARD_FETCH,
  DASHBOARD_RESPONSE,
  DASHBOARD_PARTNER_RESPONSE,
  ORDER_FAILURE,
  ORDER_FETCH,
  ORDER_RESPONSE,
  UPDATE_SEARCH_STRING,
  UPDATE_ORDER_SOURCE,
  UPDATE_DATE_RANGE,
} from './actions'

const DEFAULT_PERIOD = { months: 6 }

const rangeState = (start, end, period) => {
  const activeStartDate = moment(start).startOf('day')
  const activeEndDate = moment(end)

  return {
    activeStartDate,
    activeEndDate,
    activePeriod: period,
    activeAggregation: getAggregation(activeStartDate, activeEndDate),
  }
}

const today = easternToday()

const initialState = {
  ...rangeState(today.clone().subtract(DEFAULT_PERIOD), today, DEFAULT_PERIOD),
  orders: [],
  searchString: '',
  pageCount: 0,
  D2CExtensionInstalled: false,
  limit: 10,
  ordersRequestId: null,
  ordersStatus: 'idle',
  statisticsRequestId: null,
  statisticsStatus: 'idle',
  source: undefined,
}

export default function warranty(state = initialState, action) {
  switch (action.type) {
    case DASHBOARD_FETCH:
      return {
        ...state,
        statisticsRequestId: action.requestId,
        statisticsStatus: 'loading',
      }
    case DASHBOARD_RESPONSE: {
      if (action.requestId !== state.statisticsRequestId) return state
      const { statistics } = action
      const {
        money_by_currency: moneyByCurrency,
        total_revenue,
        total_profit,
        net_profit,
      } = statistics
      return {
        ...state,
        statisticsStatus: 'loaded',
        warrantiesOverTime: statistics.warranties,
        totalSold: statistics.total_sold,
        totalOrders: statistics.total_orders,
        moneyByCurrency: moneyByCurrency?.length
          ? moneyByCurrency
          : [{ currency: 'USD', total_revenue, total_profit, net_profit }],
        cancelledWarrantyOrders: statistics.cancelled_warranties,
      }
    }
    case DASHBOARD_FAILURE:
      if (action.requestId !== state.statisticsRequestId) return state
      return { ...state, statisticsStatus: 'failed' }
    case ORDER_FETCH:
      return {
        ...state,
        ordersRequestId: action.requestId,
        ordersStatus: 'loading',
      }
    case ORDER_RESPONSE:
      if (action.requestId !== state.ordersRequestId) return state
      return {
        ...state,
        orders: action.orders,
        ordersStatus: 'loaded',
        pageCount: Math.ceil(action.total / state.limit),
      }
    case ORDER_FAILURE:
      if (action.requestId !== state.ordersRequestId) return state
      return { ...state, ordersStatus: 'failed' }
    case DASHBOARD_PARTNER_RESPONSE:
      return Object.assign({}, state, {
        partner: action.partner,
      })
    case UPDATE_SEARCH_STRING: {
      return {
        ...state,
        searchString: action.searchString,
      }
    }
    case UPDATE_ORDER_SOURCE: {
      return {
        ...state,
        source: action.source,
      }
    }
    case UPDATE_DATE_RANGE:
      return {
        ...state,
        ...rangeState(
          action.activeStartDate,
          action.activeEndDate,
          action.activePeriod ?? null
        ),
      }
    default:
      return state
  }
}
